import { Routes } from "@generouted/react-router";
import { addAppInsights } from "libs/analytics/appinsights";
import { createRoot } from "react-dom/client";

addAppInsights();

createRoot(document.getElementById("root")!).render(<Routes />);
